<template>
  <div id="c-python-run-iframe" :style="isSkulptDraw || isShowFrame ? styleW : styleNW">

    <div v-show="this.isSkulptDraw || isShowFrame" class="python-run-title-bar" @click="showFrame(!isShowFrame)" :style="isSkulptDraw ? '' : 'cursor: pointer;'">
      <template v-if="!isSkulptDraw">
        <i v-if="isShowFrame" class="el-icon-caret-right"></i>
        <i v-else class="el-icon-caret-left"></i>
      </template>
      <span v-else style="padding-left: 5px"></span>
      <span>绘图显示区：</span>
    </div>
    <iframe class="python-run-iframe" name="pythonRunIframe" id="sk-iframe" v-if="showIframe"
            frameborder="0" :src="frameUrl"></iframe>
    <div v-if="resizeType == 'h'" class="python-over"></div>
  </div>
</template>

<script type="text/babel">
  import { mapGetters } from 'vuex';
  import { onEvent, emitEvent } from '../../utils/eventBus/vueEvent';
  import Events from '../../scripts/events/index';
  import iframe from '../../scripts/iframe/index';
  import consoleStyle from '../ide/consoleStyle';
  import aegis from '../../scripts/aegis';

  export default {
    name: 'c-python-run-iframe',
    data() {
      return {
        isShowFrame: false,
        styleW: 'width: 480px;',
        styleNW: 'width: 10px; border-left: none;',
        showIframe: true,
      }
    },
    props: {
      resizeType: String
    },
    computed: {
      ...mapGetters(['ideCode', 'prevCode', 'isSkulptDraw', 'isRunLocal', 'skulptReady', 'isPyRuntimeCom']),
      frameUrl() {
        const url = 'https://qceit-static-1258274959.cos.ap-guangzhou.myqcloud.com/editor/skulpt0-9/app/index210315.html';
        return `${url}?origin=${encodeURIComponent(location.origin)}`;
      },
    },
    mounted() {
      onEvent(Events.RUN_PYTHON_CODE_LOCAL, (code, stop, reload) => {
        if (this.isPyRuntimeCom) {
          return;
        }
        if (stop) {
          const iframe = document.getElementById('sk-iframe');
          iframe.src = this.frameUrl;
          this.isShowFrame = false;
          emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getRun('...停止运行') })
          if (reload) {
            this.showIframe = false;
            this.$nextTick(() => {
              this.showIframe = true;
            });
          }
          return;
        }
        if (code && code.indexOf('import turtle') >= 0) {
          this.isShowFrame = true;
        } else {
          this.isShowFrame = false;
        }
        iframe.runPythonLocal(code);
      })
      if (this.isRunLocal) {
        setTimeout(this.checkLoaded, 16000)
      }
    },
    methods: {
      showFrame(boo) {
        console.log('--this.:', this.isSkulptDraw);
        this.isShowFrame = boo;
      },
      checkLoaded() {
        if (this.isRunLocal && !this.skulptReady) {
          aegis.report('iframe python load error');
          emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getErr('python初始化超时，切换python运行时...') })
          // this.$store.dispatch('setIsLocalIde', true)
          this.$store.dispatch('setIsPyRuntimeCom', true)
        }
      }
    }
  }
</script>

<style lang="scss">

  @import "../../assets/scss/base/variables.scss";

  #c-python-run-iframe {
    display: flex;
    flex-direction: column;
    border-left: 1px solid #b4b4b4;
    position: relative;

    .python-run-title-bar {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0 0 0 5px;
      border-bottom: 1px solid #dddddd;
    }

    .python-run-title-btn {
      padding: 5px;
      font-size: 14px;
    }

    .python-run-iframe {
      height: 482px;
    }

    .python-over {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: rgba(255,255,255,0.01);
    }
  }
</style>
